export const GLOSSARY_CATEGORIES = [
  "GEO",
  "AI Search",
  "Semantic SEO",
  "Entity SEO",
  "Structured Data",
  "Knowledge Graph",
  "LLM",
];

export const GLOSSARY = [
  {
    slug: "generative-engine-optimization",
    term: "Generative Engine Optimization (GEO)",
    category: "GEO",
    definition: "Generative Engine Optimization is the practice of optimizing content, structured data, entities and authority so generative AI engines can discover, understand, trust and cite a brand in their answers.",
    example: "A manufacturer implementing product schema and entity pages so ChatGPT recommends it to procurement buyers is practising GEO.",
    related: ["ai-search-optimization", "entity-authority", "answer-engine-optimization"],
  },
  {
    slug: "ai-search-optimization",
    term: "AI Search Optimization",
    category: "AI Search",
    definition: "The broader discipline of optimizing a brand's presence across AI-powered search surfaces and answer engines, encompassing GEO, structured data and entity work.",
    example: "Optimizing for Google AI Overviews and Perplexity citations simultaneously.",
    related: ["generative-engine-optimization", "answer-engine-optimization"],
  },
  {
    slug: "answer-engine-optimization",
    term: "Answer Engine Optimization (AEO)",
    category: "AI Search",
    definition: "Optimizing content to win direct answers, featured snippets and voice results by structuring concise, authoritative responses to specific questions.",
    example: "Adding a 45-word answer block that AI can lift verbatim as a response.",
    related: ["generative-engine-optimization", "structured-data"],
  },
  {
    slug: "entity-authority",
    term: "Entity Authority",
    category: "Entity SEO",
    definition: "The degree to which AI systems recognise a brand as a distinct, trustworthy entity, based on consistent information, knowledge-graph presence and credible references.",
    example: "A brand with a Wikidata entry, consistent profiles and authoritative citations has strong entity authority.",
    related: ["knowledge-graph", "generative-engine-optimization"],
  },
  {
    slug: "knowledge-graph",
    term: "Knowledge Graph",
    category: "Knowledge Graph",
    definition: "A structured network of entities and their relationships that AI and search systems use to understand and connect real-world concepts.",
    example: "Google's Knowledge Graph and Wikidata inform how AI describes your brand.",
    related: ["entity-authority", "structured-data"],
  },
  {
    slug: "structured-data",
    term: "Structured Data (Schema)",
    category: "Structured Data",
    definition: "Machine-readable markup (typically JSON-LD) that describes the meaning of content, enabling AI and search engines to interpret facts without ambiguity.",
    example: "Organization and FAQPage JSON-LD schema helping AI cite your business accurately.",
    related: ["knowledge-graph", "answer-engine-optimization"],
  },
  {
    slug: "semantic-seo",
    term: "Semantic SEO",
    category: "Semantic SEO",
    definition: "Optimizing content around meaning, topics and relationships rather than isolated keywords, so AI understands context and depth.",
    example: "Building comprehensive topic clusters that cover a subject end-to-end.",
    related: ["topical-authority", "entity-authority"],
  },
  {
    slug: "topical-authority",
    term: "Topical Authority",
    category: "Semantic SEO",
    definition: "The perceived depth and credibility of a brand's coverage of a subject area, signalling expertise to AI and search systems.",
    example: "A firm publishing an interconnected library on GEO establishes topical authority.",
    related: ["semantic-seo", "entity-authority"],
  },
  {
    slug: "llm",
    term: "Large Language Model (LLM)",
    category: "LLM",
    definition: "An AI model trained on vast text data to understand and generate human-like language, powering assistants like ChatGPT, Gemini and Claude.",
    example: "GPT-5 and Claude are large language models that synthesise answers and cite sources.",
    related: ["llm-optimization", "generative-engine-optimization"],
  },
  {
    slug: "llm-optimization",
    term: "LLM Optimization (LLMO)",
    category: "LLM",
    definition: "Shaping how large language models represent and recommend a brand within their generated responses.",
    example: "Ensuring LLMs describe your product's differentiators accurately.",
    related: ["llm", "generative-engine-optimization"],
  },
  {
    slug: "ai-citation",
    term: "AI Citation",
    category: "AI Search",
    definition: "A reference or attribution to a brand or source within an AI-generated answer, often the primary visibility outcome of GEO.",
    example: "Perplexity naming your company as a source is an AI citation.",
    related: ["generative-engine-optimization", "entity-authority"],
  },
  {
    slug: "zero-click-search",
    term: "Zero-Click Search",
    category: "AI Search",
    definition: "A search interaction where the user gets their answer directly from the results or AI response without clicking through to a website.",
    example: "An AI Overview answering a question fully, so the user never visits a site.",
    related: ["answer-engine-optimization", "generative-engine-optimization"],
  },
];

export const getTerm = (slug) => GLOSSARY.find((t) => t.slug === slug);
